import { utxAuthGetAccessTokenByRefreshToken, utxUserFeatureList } from '@utx/utx-client';
import * as Linking from 'expo-linking';
import { useEffect, useState } from 'react';
import { useStore } from 'store/store';
import { Vendor } from 'store/types';

export const useInit = () => {
  const store = useStore();
  const [url, setUrl] = useState<string | null>(null);
  const [params, setParams] = useState<Record<string, string>>({});
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    const getUrlAsync = async () => {
      const initialUrl = await Linking.getInitialURL();

      if (!initialUrl) {
        return;
      }

      const { queryParams, path } = Linking.parse(initialUrl);
      setUrl(initialUrl);

      if (!queryParams) {
        return {
          url: path,
          params
        };
      }

      let { vendor, locale, theme, token } = queryParams;
      let newParams = {};

      // Vendor === 'UTGL' | 'FGA' | 'GBF'
      if (vendor && isString(vendor)) {
        if (vendor === 'unitrust') {
          vendor = 'utgl';
        }
        newParams = { ...newParams, vendor };
        const vIndex = Object.keys(Vendor).indexOf(vendor);
        const brand = Object.values(Vendor)[vIndex] as Vendor;
        store.changeBrand(brand);
        store.changeVendor(vendor as Vendor);
        // getEarnVendorTranslationKey()
      }

      // Locale for i18n
      if (locale && isString(locale)) {
        console.log('@locale', locale);
        newParams = { ...newParams, locale };
        store.changeLocale(locale);
      }

      // Theme
      if (theme && isString(theme)) {
        newParams = { ...newParams, theme };
        store.changeTheme(theme as 'light' | 'dark');
      }

      // Token
      if (token && isString(token)) {
        const authToken = await fetchAccessToken(token);
        if (authToken) {
          // const mockAuth =
          //   'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6IjQyNzJhMWJlLWE1OWMtNGNlZC04ZTg2LTJjZGE2NDI5NDc0MyIsImFjY2lkIjoiNzJiMGQ3ZGEtNzNkNS00NTBlLTlkYWYtOTk4YjM5MjEyOGE2IiwiYXBwaWQiOiIxNzk1NzdiMi05NDliLTQ2YjktOTI4YS00N2JkYzRiMjM0OTgiLCJhaGlkIjoiYmU3ZmY2N2EtOTZhNi00OWNiLWJmOWYtMDIyOWIyZGIwYTA3IiwicmVmcmVzaGlkIjoiNTcyMjc3YjEtNWFmOC00YWNmLTk0OTYtYjU5ODM3NDU1YjY5IiwiaWF0IjoxNjY3NzU5NTIxLCJleHAiOjE2Njc3NjEzMjF9.QjGHmdnT9pr1kzruCeZ4iMDG5SQDTDjDg6fw3RZIbLY';
          // newParams = { ...newParams, authToken: mockAuth };
          // store.changeAuthToken(mockAuth);
          newParams = { ...newParams, authToken };
          store.changeAuthToken(authToken);
          const userFeatures = await fetchUserFeatureList();
          if (!!userFeatures) {
            store.changeUserFeatures(userFeatures);
          }
        }
      }

      setParams(newParams);

      setIsReady(true);
    };

    getUrlAsync();
  }, []);

  return { url, params, isReady };
};

const fetchAccessToken = async (authToken: string) => {
  const authTokenResponse = await utxAuthGetAccessTokenByRefreshToken({
    token: authToken
  });
  if (!authTokenResponse) {
    return;
  }

  return authTokenResponse.data.token;
};

const fetchUserFeatureList = async () => {
  const userFeatures = await utxUserFeatureList();
  if (!userFeatures) {
    return;
  }
  return userFeatures.data;
};

const isString = (value: any): value is string => {
  return typeof value === 'string';
};
